import BaseModel from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class ArchiveMessageModalModel extends BaseModel {
  message = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
  };

  attributeHints = {
  };

  attributeLabels = {
    message: i18n.t('Message'),
  };
}
